var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;



//////////////////
// WEBPACK FOOTER
// ./~/global/window.js
// module id = 18
// module chunks = 1